export default "__VITE_ASSET__DOuN09r1__"